import '@/app/assets/main.css'
import '@fontsource-variable/inter/index.css'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import { createYmaps } from 'vue-yandex-maps';
import { i18n } from '@/shared/i18n'
import App from './App.vue'
import router from '@/app/router/router'
import { VueQueryPlugin } from '@tanstack/vue-query'
import VueApexCharts from 'vue3-apexcharts'
// import * as Sentry from "@sentry/vue";

const application = createApp(App)

// Sentry.init({
//   app: application,
//   dsn: "https://97e5ca2e7a0a7f4ef322f839b7a8f871@o4511845882855424.ingest.de.sentry.io/4511845998264400",
//   dataCollection: {
//     userInfo: false,
//     httpBodies: [],
//   },
// });

application.use(createPinia())
application.use(router)
application.use(i18n)
application.use(VueQueryPlugin)
application.use(VueApexCharts)
application.component('ApexChart', VueApexCharts)
application.use(createYmaps({
  apikey: 'a64bd29c-f95b-42cb-946f-27517a3ef3cc',
}));
export default application
